/**
 * @description: 用于监听滚动行为/window的resize监听/滚动区域内的dom动态增删dom来添加阴影
 * @return {HTMLElement} elementRef 要滚动监听的dom
 * @return {scrollPosition} IScrollPosition 监听的位置
 */
import { onUnmounted, ref, watch } from 'vue'

type IScrollPosition = 'top' | 'scrolling' | 'bottom' // 滚动到最顶部、滚动中、滚动到最底部

export function useScroll() {
  const scrollRef = ref<HTMLElement>() // 监听滚动的dom
  const scrollPosition = ref<IScrollPosition>() // 滚动到的位置
  const isHasScrollBar = ref(false) // 是否有滚动条
  let observer: ResizeObserver // 监听dom内容发生变化

  // 滚动事件
  const handleScroll = (event: Event) => {
    const target = event.target as HTMLElement
    getSrcollPosition(target)
  }
  // 判断滚动位置
  const getSrcollPosition = (target: HTMLElement) => {
    // 判断是否有滚动体条
    if (target.scrollHeight > target.offsetHeight) {
      isHasScrollBar.value = true
    } else {
      isHasScrollBar.value = false
    }
    if (!!target.scrollTop) {
      // 有0.5px的误差 故-1
      if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 1) {
        // 在最底部
        scrollPosition.value = 'bottom'
      } else {
        // 滚动中
        scrollPosition.value = 'scrolling'
      }
    } else {
      // 在最顶部
      scrollPosition.value = 'top'
    }
  }

  // 监听滚动容器高度的变化
  watch(
    scrollRef,
    () => {
      if (scrollRef.value) {
        scrollRef.value!.addEventListener('scroll', handleScroll)
      }
    },
    {
      immediate: true,
      deep: true
    }
  )

  watch(
    scrollRef,
    () => {
      if (scrollRef.value) {
        if (!observer) {
          observer = new ResizeObserver(() => {
            if (scrollRef.value) {
              // 检查容器的高度变化
              if (
                scrollRef.value!.scrollHeight > scrollRef.value!.offsetHeight
              ) {
                isHasScrollBar.value = true
              } else {
                isHasScrollBar.value = false
              }
            }
          })
          observer.observe(scrollRef.value)
        }
      }
    },
    {
      immediate: true,
      deep: true
    }
  )

  // 组件卸载停止监听
  onUnmounted(() => {
    if (observer) {
      observer.disconnect()
    }
  })
  // 组件卸载停止监听
  onUnmounted(() => {
    if (scrollRef.value) {
      scrollRef.value!.removeEventListener('scroll', handleScroll)
    }
  })

  return { scrollRef, isHasScrollBar, scrollPosition }
}
